import React, { useState } from 'react';

const KeyboardShortcutsHelp = () => {
  const [isOpen, setIsOpen] = useState(false);

  const shortcuts = [
    { category: 'Playback', items: [
      { key: 'Space', action: 'Play / Pause' },
      { key: '←', action: 'Previous Ayah' },
      { key: '→', action: 'Next Ayah' },
    ]},
    { category: 'Navigation', items: [
      { key: 'Shift + ←', action: 'Previous Surah' },
      { key: 'Shift + →', action: 'Next Surah' },
    ]},
    { category: 'Modes', items: [
      { key: 'R', action: 'Toggle Repeat' },
      { key: 'F', action: 'Focus Mode' },
    ]},
    { category: 'UI', items: [
      { key: 'Esc', action: 'Exit Focus / Collapse Player' },
    ]},
  ];

  if (!isOpen) {
    return (
      <button
        onClick={() => setIsOpen(true)}
        className="text-xs transition-all"
        style={{
          color: 'var(--text-secondary)',
          opacity: 0.6,
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.opacity = '1';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.opacity = '0.6';
        }}
      >
        ⌨️ Keyboard Shortcuts
      </button>
    );
  }

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 z-[100]"
        style={{
          background: 'rgba(0, 0, 0, 0.6)',
          backdropFilter: 'blur(4px)',
        }}
        onClick={() => setIsOpen(false)}
      />

      {/* Modal */}
      <div 
        className="fixed left-1/2 top-1/2 z-[101] w-full max-w-md p-8 rounded-2xl animate-fade-in"
        style={{
          transform: 'translate(-50%, -50%)',
          background: 'var(--bg-secondary)',
          border: '1px solid var(--border-gold)',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.4)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="mb-6">
          <h2 
            className="text-2xl font-bold mb-2"
            style={{ color: 'var(--text-arabic)' }}
          >
            Keyboard Shortcuts
          </h2>
          <p 
            className="text-sm"
            style={{ color: 'var(--text-secondary)', opacity: 0.7 }}
          >
            For a distraction-free experience
          </p>
        </div>

        {/* Shortcuts List */}
        <div className="space-y-6">
          {shortcuts.map((category) => (
            <div key={category.category}>
              <h3 
                className="text-xs font-semibold uppercase tracking-wide mb-3"
                style={{ color: 'var(--gold-hover)' }}
              >
                {category.category}
              </h3>
              <div className="space-y-2">
                {category.items.map((item) => (
                  <div 
                    key={item.key} 
                    className="flex items-center justify-between"
                  >
                    <span 
                      className="text-sm"
                      style={{ color: 'var(--text-english)' }}
                    >
                      {item.action}
                    </span>
                    <kbd 
                      className="px-3 py-1.5 rounded-lg text-xs font-mono font-medium"
                      style={{
                        background: 'rgba(148, 163, 184, 0.08)',
                        border: '1px solid var(--border-default)',
                        color: 'var(--text-secondary)',
                      }}
                    >
                      {item.key}
                    </kbd>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Close Button */}
        <button
          onClick={() => setIsOpen(false)}
          className="mt-8 w-full px-6 py-3 rounded-lg font-medium transition-all"
          style={{
            background: 'var(--gold-muted)',
            border: '1px solid var(--border-gold)',
            color: 'var(--gold-hover)',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'rgba(212, 175, 55, 0.25)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'var(--gold-muted)';
          }}
        >
          Got it
        </button>
      </div>
    </>
  );
};

export default KeyboardShortcutsHelp;

